import { Map, List } from "immutable";

import {
  ADMIN_PARTNER_CLASS_ADMIN_LIST_REQUEST,
  ADMIN_PARTNER_CLASS_ADMIN_LIST_SUCCESS,
  ADMIN_PARTNER_CLASS_ADMIN_LIST_FAILURE,
  ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_REQUEST,
  ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_SUCCESS,
  ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_FAILURE,
} from "./actions";
import Logger from "../../../lib/Logger";

export default function adminPartnerClassesAdmin(
  state = Map({
    isLoading: false,
    isCSVDownloading: false,
    pages: {},
    total: 0,
  }),
  action
) {
  Logger.log(
    "debug",
    `[adminPartnerClassesAdmin.reducers] adminPartnerClassesAdmin(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case ADMIN_PARTNER_CLASS_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.partnershipId]: {
              [action.order]: {
                [action.limit]: {
                  [action.page]: null,
                },
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ["pages", action.partnershipId, action.order, action.limit, action.page],
          List(action.result)
        );

    case ADMIN_PARTNER_CLASS_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          adminPartnerClassesAdmin: {
            [action.partnershipId]: {
              total: action.total,
            },
          },
          lastUpdated: action.receivedAt,
        })
        .setIn(
          [
            "adminPartnerClassesAdmin",
            action.partnershipId,
          ],
          List(action.result)
        );

    case ADMIN_PARTNER_CLASS_ADMIN_PARTNERSHIP_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });


    default:
      return state;
  }
}

Logger.log("silly", `adminPartnerClassesAdmin.reducers loaded.`);
